import React, { useState } from 'react'
import { NextPage } from 'next'
import Blogs from '../../components/Blogs/Blogs'
import { API_BASE_URL } from '../../lib/constants'

export const getServerSideProps = async (context: any) => {
	const currentPage = context?.query?.page != undefined ? context?.query?.page : 1
	const type = context?.query?.type || ''
	if (context?.query?.search) {
		const res = await fetch(`${API_BASE_URL}blog-search?value=${context?.query?.search}&type=${type}`)
		const data = await res?.json()
		return {
			props: {
				blogs: data,
				type: type
			}
		}
	} else {
		const res = await fetch(`${API_BASE_URL}blog?page=${currentPage}`)
		const data = await res?.json()
		return {
			props: {
				blogs: data,
				type: type
			}
		}
	}
}

const blogs: NextPage = ({ blogs, type }: any) => {
	return <Blogs blogs={blogs} type={type}></Blogs>
}

export default blogs
